import {buildField} from '@eitje/form'
import {Layout, EitjeButton, Text} from '~/components'

const Field = ({value, onChange}) => {
	const handleChange = event => {
		const file = event.target.files[0]
		onChange(file)
	}

	return (
		<Layout>
			<Text truncate>{value?.name}</Text>
			{!value && <EitjeButton iconLeft="upload" />}
			<input type="file" onChange={handleChange} accept=".xlsx,.xls" style={{display: 'none'}} />
		</Layout>
	)
}

export const FileField = buildField(Field, ({value}) => {
	const inputPosition = value ? 'left' : 'right'
	const clearIcon = inputPosition === 'left'

	return {
		className: 'eitje-asset-picker eitje-file-picker',
		clearIcon,
		inputPosition,
	}
})
